import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
})
export class PdfPreviewComponent {
  @Input()
  url: string;

  loading: boolean = true;

  constructor(public modal: NgbActiveModal) {}
}
